import { c as _c } from "react/compiler-runtime";
import { IcoCloseSmall16, IcoFilter16 } from '@onefootprint/icons';
import { InlineAlert, LinkButton, Popover, Select } from '@onefootprint/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { ConditionOption } from './condition-options';
import { conditionText, type ReportCondition } from './report-outline';
type ConditionEditorProps = {
  when: ReportCondition;
  options: ConditionOption[];
  editable: boolean;
  onChange: (when: ReportCondition | null) => void;
};
const ConditionEditor = t0 => {
  const $ = _c(127);
  const {
    when,
    options,
    editable,
    onChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.report"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  const [open, setOpen] = useState(false);
  let outputUnavailable;
  let t2;
  if ($[1] !== options || $[2] !== when) {
    let t3;
    if ($[5] !== when) {
      t3 = option => option.key === when.key;
      $[5] = when;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    const selected = options.find(t3);
    outputUnavailable = !selected;
    t2 = selected !== undefined && !selected.values.includes(when.value);
    $[1] = options;
    $[2] = when;
    $[3] = outputUnavailable;
    $[4] = t2;
  } else {
    outputUnavailable = $[3];
    t2 = $[4];
  }
  const valueUnavailable = t2;
  let t3;
  if ($[7] !== outputUnavailable || $[8] !== t || $[9] !== valueUnavailable || $[10] !== when) {
    t3 = outputUnavailable ? t(_temp, {
      output: when.key
    }) : valueUnavailable ? t(_temp2, {
      output: when.key,
      value: when.value
    }) : null;
    $[7] = outputUnavailable;
    $[8] = t;
    $[9] = valueUnavailable;
    $[10] = when;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const unavailableMessage = t3;
  let t4;
  if ($[12] !== editable || $[13] !== t || $[14] !== unavailableMessage) {
    t4 = unavailableMessage && <InlineAlert variant="warning">{unavailableMessage} {editable && t(_temp3)}</InlineAlert>;
    $[12] = editable;
    $[13] = t;
    $[14] = unavailableMessage;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const warning = t4;
  let t5;
  if ($[16] !== onChange) {
    t5 = () => {
      onChange(null);
      setOpen(false);
    };
    $[16] = onChange;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const remove = t5;
  if (!editable || options.length === 0) {
    let t6;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <IcoFilter16 color="tertiary" />;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    let t7;
    if ($[19] !== t || $[20] !== when) {
      t7 = t(_temp4, {
        condition: conditionText(when)
      });
      $[19] = t;
      $[20] = when;
      $[21] = t7;
    } else {
      t7 = $[21];
    }
    let t8;
    if ($[22] !== editable || $[23] !== remove || $[24] !== t) {
      t8 = editable && <button type="button" aria-label={t(_temp5)} onClick={remove} className="cursor-pointer rounded-sm p-1 hover:bg-hover"><IcoCloseSmall16 color="tertiary" /></button>;
      $[22] = editable;
      $[23] = remove;
      $[24] = t;
      $[25] = t8;
    } else {
      t8 = $[25];
    }
    let t9;
    if ($[26] !== t7 || $[27] !== t8) {
      t9 = <p className="flex w-fit items-center gap-1 rounded-sm border border-tertiary py-0.5 pr-1.5 pl-1 text-caption-2 text-secondary">{t6}{t7}{t8}</p>;
      $[26] = t7;
      $[27] = t8;
      $[28] = t9;
    } else {
      t9 = $[28];
    }
    let t10;
    if ($[29] !== t9 || $[30] !== warning) {
      t10 = <div className="flex min-w-0 flex-col gap-2">{t9}{warning}</div>;
      $[29] = t9;
      $[30] = warning;
      $[31] = t10;
    } else {
      t10 = $[31];
    }
    return t10;
  }
  let t6;
  if ($[32] !== options) {
    t6 = key => options.find(option_0 => option_0.key === key)?.values ?? [];
    $[32] = options;
    $[33] = t6;
  } else {
    t6 = $[33];
  }
  const valuesFor = t6;
  let t7;
  if ($[34] !== options || $[35] !== outputUnavailable || $[36] !== t || $[37] !== when.key) {
    let t8;
    if ($[39] !== outputUnavailable || $[40] !== t || $[41] !== when.key) {
      t8 = outputUnavailable && when.key ? [{
        value: when.key,
        label: t(_temp7, {
          value: when.key
        }),
        disabled: true
      }] : [];
      $[39] = outputUnavailable;
      $[40] = t;
      $[41] = when.key;
      $[42] = t8;
    } else {
      t8 = $[42];
    }
    t7 = [...options.map(_temp6), ...t8];
    $[34] = options;
    $[35] = outputUnavailable;
    $[36] = t;
    $[37] = when.key;
    $[38] = t7;
  } else {
    t7 = $[38];
  }
  const keyOptions = t7;
  let t8;
  if ($[43] !== t || $[44] !== valuesFor || $[45] !== when.key || $[46] !== when.value) {
    const values = valuesFor(when.key);
    t8 = [...values.map(_temp8), ...(!values.includes(when.value) && when.value ? [{
      value: when.value,
      label: t(_temp9, {
        value: when.value
      }),
      disabled: true
    }] : [])];
    $[43] = t;
    $[44] = valuesFor;
    $[45] = when.key;
    $[46] = when.value;
    $[47] = t8;
  } else {
    t8 = $[47];
  }
  const valueOptions = t8;
  let t9;
  if ($[48] !== t) {
    t9 = t(_temp10);
    $[48] = t;
    $[49] = t9;
  } else {
    t9 = $[49];
  }
  let t10;
  if ($[50] !== onChange || $[51] !== valuesFor || $[52] !== when) {
    t10 = key_0 => onChange({
      ...when,
      key: key_0,
      value: valuesFor(key_0)[0] ?? ""
    });
    $[50] = onChange;
    $[51] = valuesFor;
    $[52] = when;
    $[53] = t10;
  } else {
    t10 = $[53];
  }
  let t11;
  if ($[54] !== keyOptions || $[55] !== outputUnavailable || $[56] !== t10 || $[57] !== t9 || $[58] !== when.key) {
    t11 = <Select aria-label={t9} hasError={outputUnavailable} onChange={t10} options={keyOptions} size="compact" value={when.key} />;
    $[54] = keyOptions;
    $[55] = outputUnavailable;
    $[56] = t10;
    $[57] = t9;
    $[58] = when.key;
    $[59] = t11;
  } else {
    t11 = $[59];
  }
  let t12;
  if ($[60] !== t) {
    t12 = t(_temp11);
    $[60] = t;
    $[61] = t12;
  } else {
    t12 = $[61];
  }
  let t13;
  if ($[62] !== onChange || $[63] !== when) {
    t13 = op => onChange({
      ...when,
      op: op === "isNot" ? "isNot" : "is"
    });
    $[62] = onChange;
    $[63] = when;
    $[64] = t13;
  } else {
    t13 = $[64];
  }
  let t14;
  if ($[65] !== t) {
    t14 = t(_temp12);
    $[65] = t;
    $[66] = t14;
  } else {
    t14 = $[66];
  }
  let t15;
  if ($[67] !== t14) {
    t15 = {
      value: "is",
      label: t14
    };
    $[67] = t14;
    $[68] = t15;
  } else {
    t15 = $[68];
  }
  let t16;
  if ($[69] !== t) {
    t16 = t(_temp13);
    $[69] = t;
    $[70] = t16;
  } else {
    t16 = $[70];
  }
  let t17;
  if ($[71] !== t16) {
    t17 = {
      value: "isNot",
      label: t16
    };
    $[71] = t16;
    $[72] = t17;
  } else {
    t17 = $[72];
  }
  let t18;
  if ($[73] !== t15 || $[74] !== t17) {
    t18 = [t15, t17];
    $[73] = t15;
    $[74] = t17;
    $[75] = t18;
  } else {
    t18 = $[75];
  }
  let t19;
  if ($[76] !== t12 || $[77] !== t13 || $[78] !== t18 || $[79] !== when.op) {
    t19 = <div className="w-26 shrink-0"><Select aria-label={t12} onChange={t13} options={t18} size="compact" value={when.op} /></div>;
    $[76] = t12;
    $[77] = t13;
    $[78] = t18;
    $[79] = when.op;
    $[80] = t19;
  } else {
    t19 = $[80];
  }
  let t20;
  if ($[81] !== t) {
    t20 = t(_temp14);
    $[81] = t;
    $[82] = t20;
  } else {
    t20 = $[82];
  }
  let t21;
  if ($[83] !== onChange || $[84] !== when) {
    t21 = value_0 => onChange({
      ...when,
      value: value_0
    });
    $[83] = onChange;
    $[84] = when;
    $[85] = t21;
  } else {
    t21 = $[85];
  }
  let t22;
  if ($[86] !== outputUnavailable || $[87] !== t20 || $[88] !== t21 || $[89] !== valueOptions || $[90] !== valueUnavailable || $[91] !== when.value) {
    t22 = <div className="min-w-0 flex-1"><Select aria-label={t20} disabled={outputUnavailable} hasError={valueUnavailable} onChange={t21} options={valueOptions} size="compact" value={when.value} /></div>;
    $[86] = outputUnavailable;
    $[87] = t20;
    $[88] = t21;
    $[89] = valueOptions;
    $[90] = valueUnavailable;
    $[91] = when.value;
    $[92] = t22;
  } else {
    t22 = $[92];
  }
  let t23;
  if ($[93] !== t19 || $[94] !== t22) {
    t23 = <div className="flex items-start gap-2">{t19}{t22}</div>;
    $[93] = t19;
    $[94] = t22;
    $[95] = t23;
  } else {
    t23 = $[95];
  }
  let t24;
  if ($[96] !== t) {
    t24 = t(_temp15);
    $[96] = t;
    $[97] = t24;
  } else {
    t24 = $[97];
  }
  let t25;
  if ($[98] !== remove || $[99] !== t24) {
    t25 = <div className="mt-1 border-t border-tertiary pt-2.5"><LinkButton destructive={true} onClick={remove} variant="caption-3">{t24}</LinkButton></div>;
    $[98] = remove;
    $[99] = t24;
    $[100] = t25;
  } else {
    t25 = $[100];
  }
  let t26;
  if ($[101] !== t11 || $[102] !== t23 || $[103] !== t25) {
    t26 = <div className="flex w-[340px] flex-col gap-2 p-2.5">{t11}{t23}{t25}</div>;
    $[101] = t11;
    $[102] = t23;
    $[103] = t25;
    $[104] = t26;
  } else {
    t26 = $[104];
  }
  const content = t26;
  let t27;
  if ($[105] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <IcoFilter16 color="tertiary" />;
    $[105] = t27;
  } else {
    t27 = $[105];
  }
  let t28;
  if ($[106] !== t || $[107] !== when) {
    t28 = t(_temp16, {
      condition: conditionText(when)
    });
    $[106] = t;
    $[107] = when;
    $[108] = t28;
  } else {
    t28 = $[108];
  }
  let t29;
  if ($[109] !== t28) {
    t29 = <button className="flex cursor-pointer items-center gap-1 rounded-l-sm px-1 py-0.5 transition-colors hover:bg-hover hover:text-primary" type="button">{t27}{t28}</button>;
    $[109] = t28;
    $[110] = t29;
  } else {
    t29 = $[110];
  }
  let t30;
  if ($[111] !== content || $[112] !== open || $[113] !== t29) {
    t30 = <Popover align="start" content={content} controlledOpen={open} onControlledOpenChange={setOpen} side="bottom">{t29}</Popover>;
    $[111] = content;
    $[112] = open;
    $[113] = t29;
    $[114] = t30;
  } else {
    t30 = $[114];
  }
  let t31;
  if ($[115] !== t) {
    t31 = t(_temp17);
    $[115] = t;
    $[116] = t31;
  } else {
    t31 = $[116];
  }
  let t32;
  if ($[117] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <IcoCloseSmall16 color="tertiary" />;
    $[117] = t32;
  } else {
    t32 = $[117];
  }
  let t33;
  if ($[118] !== remove || $[119] !== t31) {
    t33 = <button aria-label={t31} className="flex cursor-pointer items-center self-stretch rounded-r-sm pr-1 pl-0.5 transition-colors hover:bg-hover" onClick={remove} type="button">{t32}</button>;
    $[118] = remove;
    $[119] = t31;
    $[120] = t33;
  } else {
    t33 = $[120];
  }
  let t34;
  if ($[121] !== t30 || $[122] !== t33) {
    t34 = <span className="flex w-fit items-center rounded-sm border border-tertiary text-caption-2 text-secondary">{t30}{t33}</span>;
    $[121] = t30;
    $[122] = t33;
    $[123] = t34;
  } else {
    t34 = $[123];
  }
  let t35;
  if ($[124] !== t34 || $[125] !== warning) {
    t35 = <div className="flex min-w-0 flex-col gap-2">{t34}{warning}</div>;
    $[124] = t34;
    $[125] = warning;
    $[126] = t35;
  } else {
    t35 = $[126];
  }
  return t35;
};
export default ConditionEditor;
function _temp($) {
  return $.conditionOutputUnavailable;
}
function _temp2($_0) {
  return $_0.conditionValueUnavailable;
}
function _temp3($_1) {
  return $_1.conditionUnavailableFix;
}
function _temp4($_2) {
  return $_2.conditionSummary;
}
function _temp5($_3) {
  return $_3.conditionRemove;
}
function _temp6(option_1) {
  return {
    value: option_1.key,
    label: option_1.key
  };
}
function _temp7($_4) {
  return $_4.conditionUnavailableOption;
}
function _temp8(value) {
  return {
    value,
    label: value
  };
}
function _temp9($_5) {
  return $_5.conditionUnavailableOption;
}
function _temp10($_6) {
  return $_6.conditionKeyAria;
}
function _temp11($_7) {
  return $_7.conditionOpAria;
}
function _temp12($_8) {
  return $_8.conditionIs;
}
function _temp13($_9) {
  return $_9.conditionIsNot;
}
function _temp14($_10) {
  return $_10.conditionValueAria;
}
function _temp15($_11) {
  return $_11.conditionRemove;
}
function _temp16($_12) {
  return $_12.conditionSummary;
}
function _temp17($_13) {
  return $_13.conditionRemove;
}